import { PageView } from './PageView';
import { Provider } from './Provider';

export const PostHog = {
  PageView,
  Provider,
};
